<template lang="html">
  <div class="overlayt" @click="preventClose">
    <div class="popupt" @click="preventClose">

      <div class="container">
        <img src="static/imgs/kopce.jpgg" alt="Avatar" class="image">
        <!-- <div class="overlay">
          <div class="text">Paradajz</div>
        </div> -->
      </div>
      <div class="slideshow-container">

                    <div class="opis" >
                      <img src="static/imgs/semena.png" alt="">
                      <div class="tekst">
                        <p><strong>Nirit Seeds Ltd.</strong> je izraelski proizvođač semena osnovan sa ciljem da istražuje, vrši ukrštanja i selekciju, proizvodi i distribuira najnaprednije hibride povrća. Niritovi selekcioneri, čije je bogato iskustvo rezultat višegodišnjeg profesionalnog rada, mogu se svrstati u red najboljih svetskih stručnjaka na polju ukrštanja i selekcije hibrida. Nirit Seeds Ltd. ostvaruje izuzetno zapažene rezultate na svetskom tržištu u plasmanu svojih semena. Niritovi hibridi isprobani su i testirani u vrlo strogim uslovima i danas se uzgajaju u više od 70 zemalja sveta, na svim kontinentima. Nirit Seeds i dalje svakodnevno ulaže u istraživanje i razvoj sa ciljem da svojim kupcima ponudi seme budućnosti.</p>
                      </div>
                    </div>

    </div>

      <button type="button" name="button" @click="setmanufectur(false)"><i class="fa fa-close"></i>Zatvori</button>
    </div>

  </div>
</template>

<script>
import {mapGetters, mapActions, mapMutations} from 'vuex';
export default {
  data(){
    return{
        list:null

    }
  },
  computed:{
    ...mapGetters([
      'showmanufectur'
    ]),

  },
methods:{
  ...mapMutations([
    'setmanufectur'

  ]),
  preventClose (e) {
      			e.stopPropagation()
      		},
          ...mapActions([
          ]),




},


  mounted(){

  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/manufactur.vue